import useModal from 'modules/modal/state/use-modal'
import { modalKeyToComponentMap } from './modal.utils'

const Modal = () => {
  const modal = useModal()

  const CurrentModalPanel = modal.current ? modalKeyToComponentMap[modal.current.key] : null

  return CurrentModalPanel ? <CurrentModalPanel /> : null
}

export default Modal
